export default "__VITE_ASSET__UtSd2wWiGs0Sim15oE6Xxg__"